/**
 * Monthly assistant question allowance.
 * Homeowner rows are ai_conversations since the first of the month (UTC).
 * The default cap is 20. AI_HOMEOWNER_MONTHLY_LIMIT overrides it on the server,
 * and REACT_APP_AI_HOMEOWNER_MONTHLY_LIMIT overrides it in the browser.
 */

const AI_MONTHLY_QUESTION_LIMIT = 20;

function monthlyQuestionLimit(env = {}) {
  const source = env || {};
  const raw = parseInt(source.AI_HOMEOWNER_MONTHLY_LIMIT || source.REACT_APP_AI_HOMEOWNER_MONTHLY_LIMIT, 10);
  if (Number.isFinite(raw) && raw > 0) return raw;
  return AI_MONTHLY_QUESTION_LIMIT;
}

function monthStartIso(now = new Date()) {
  const at = now instanceof Date ? now : new Date(now);
  return new Date(Date.UTC(at.getUTCFullYear(), at.getUTCMonth(), 1)).toISOString();
}

function countRowsSince(rows, sinceIso) {
  const since = new Date(sinceIso).getTime();
  if (!Number.isFinite(since)) return 0;
  return (Array.isArray(rows) ? rows : []).filter((row) => {
    const at = new Date(row && row.created_at).getTime();
    return Number.isFinite(at) && at >= since;
  }).length;
}

function questionsLeftView(used, limit) {
  const cap = Number(limit);
  const safeCap = Number.isFinite(cap) && cap > 0 ? cap : AI_MONTHLY_QUESTION_LIMIT;
  const count = Math.max(0, Number(used) || 0);
  const left = Math.max(0, safeCap - count);
  return {
    used: count,
    limit: safeCap,
    left,
    atLimit: count >= safeCap,
    label: `${left} of ${safeCap} questions left this month`,
    limitMessage: `You've used your ${safeCap} questions for this month. You can ask again next month.`,
  };
}

module.exports = {
  AI_MONTHLY_QUESTION_LIMIT,
  monthlyQuestionLimit,
  monthStartIso,
  countRowsSince,
  questionsLeftView,
};
